export const LOGOUT_TIMER = 30 * 60 * 1000; // Milliseconds

type Env = "-dev" | "-qa" | "-uat" | "-rcdr" | "-rc" | "-dr" | "local" | "";

/**
 * This code should change as long as our environment address changes
 */
export const getEnvAccordingToHostName = (): Env => {
  const hostName = window.location.hostname;
  if (
    hostName.includes("dev") ||
    hostName.includes("localhost") ||
    hostName.includes("127.0.0.1")
  )
    return "-dev";
  if (hostName.includes("qa")) return "-qa";
  if (hostName.includes("uat")) return "-uat";
  if (hostName.includes("rcdr")) return "-rcdr";
  if (hostName.includes("rc")) return "-rc";
  if (hostName.includes("dr")) return "-dr";

  return "";
};

export const api = "api/swpayadmin";
export const nameOfWidget = "index.js";
export const base_url = `https://customer-link-portal${getEnvAccordingToHostName()}.successwareg2.com/`;
// export const base_url = `http://localhost:7008/`;
export const base_url_widget = `https://bookit${getEnvAccordingToHostName()}.successware.com/`;
